<template>
  <div
    :class="txtZoom"
    class="zoom"
    v-touch="{
      left: () => $emit('siguiente'),
      right: () => $emit('anterior')
    }"
  >
    <!-- Subtítulo VDLM -->
    <v-row class="pt-4">
      <v-col>
        <strong :class="userColor + '--text text--darken-3'">
          {{ t.cuaderno.vdlm }}
        </strong>
      </v-col>
    </v-row>

    <!-- lecturas biblicas escogidas -->
    <v-row class="mb-4 zoom" v-if="!tieneTxts">
      <v-col class="flex-shrink-1 flex-grow-0">
        <v-icon>sentiment_dissatisfied</v-icon>
      </v-col>
      <v-col>
        <p>{{ t.cuaderno.msgPodrasVerTxts }}</p>
      </v-col>
    </v-row>
    <v-row class="mb-4" v-else>
      <v-col class="py-0">
        <v-row v-for="(hl, index) in txtSubrayados" :key="index">
          <v-col class="px-0 flex-shrink-1 flex-grow-0">
            <v-btn icon @click="eligeVdm(index)">
              <v-icon
                :color="hl.vdm ? userColorDark : ''"
                v-text="hl.vdm ? 'favorite' : 'favorite_border'"
              >
              </v-icon>
            </v-btn>
          </v-col>
          <v-col
            class="flex-shrink-0 flex-grow-1"
            :class="hl.vdm ? 'font-weight-bold' : ''"
          >
            <p class="zoom">{{ hl.txt }}</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <mdd-paso-subtitulo-2
      :user-color="userColor"
      :subtitle="t.mdd.escribe"
      :help="step.help[1]"
    />
    <!-- escribe -->
    <v-textarea
      id="txtOra"
      class="my-4"
      auto-grow
      prepend-icon="comment"
      :color="userColor + ' darken-3'"
      :label="t.cuaderno.tuOraPerson"
      :placeholder="t.cuaderno.escribeAquiOra"
      :value="selectedNote.ora"
      rows="5"
      @change="updateTexts('ora', $event)"
    ></v-textarea>
    <v-textarea
      id="txtComp"
      class="my-4"
      auto-grow
      persistent-hint
      prepend-icon="how_to_reg"
      :label="t.cuaderno.tuComprom"
      :placeholder="t.cuaderno.escribeAquiComp"
      :color="userColor + ' darken-3'"
      :value="selectedNote.com"
      rows="3"
      @click:append="showTime = true"
      @change="updateTexts('com', $event)"
    ></v-textarea>

    <!-- btn siguiente seccion -->
    <v-row>
      <v-col class="text-right">
        <v-btn dark :color="userColorDark" @click.stop="$emit('siguiente')">
          <v-icon left>done</v-icon>
          {{ t.app.siguiente }}
        </v-btn>
      </v-col>
    </v-row>

    <!-- selector time -->
    <v-dialog v-model="showTime" persistent width="275px">
      <v-time-picker
        v-if="showTime"
        full-width
        v-model="alm"
        ampm-in-title
        :color="userColor + ' darken-1'"
      >
        <v-row align="center" class="px-2">
          <v-col>
            <v-btn icon @click="removeTime()">
              <v-icon :color="userColor + ' darken-3'">alarm_off</v-icon>
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-btn
            text
            :color="userColor + ' darken-3'"
            @click="showTime = false"
          >
            CANCEL
          </v-btn>
          <v-btn text :color="userColor + ' darken-3'" @click="saveTime()">
            OK
          </v-btn>
        </v-row>
      </v-time-picker>
    </v-dialog>
  </div>
</template>

<script>
import MddPasoSubtitulo2 from "./MddPasoSubtitulo2";
import userConfig from "../../mixs/mixUserConfig";
import { Touch } from "vuetify/lib/directives";

export default {
  name: "mdd-paso-escribe",
  components: { MddPasoSubtitulo2 },
  props: ["lectioCod", "docId", "step", "uidLocal"],
  mixins: [userConfig],
  directives: { touch: Touch },
  data() {
    return {
      time: "",
      showTime: false,
      colors: [
        "pink",
        "purple",
        "deep-purple",
        "indigo",
        "blue",
        "light-blue",
        "cyan",
        "teal",
        "green",
        "light-green",
        "lime",
        "yellow",
        "amber",
        "orange",
        "deep-orange",
        "blue-grey"
      ]
    };
  },
  computed: {
    alm: {
      get() {
        return this.selectedNote.alm;
      },
      set(v) {
        this.time = v;
      }
    },
    color() {
      return (
        this.colors[this.cuaderno.color] + " lighten-" + this.cuaderno.light
      );
    },
    userColor() {
      return this.colors[this.cuaderno.color];
    },
    userColorDark() {
      return this.colors[this.cuaderno.color] + " darken-3";
    },
    cuaderno() {
      return this.userConfig.cua;
    },
    tieneTxts() {
      return this.selectedNote && this.selectedNote.txts
        ? this.selectedNote.txts.length > 0
        : false;
    },
    colorBtn() {
      let ora = this.selectedNote.ora !== "";
      let com = this.selectedNote.com !== "";
      return ora && com ? "primary" : "warning";
    },
    iconAlarm() {
      return this.selectedNote.alm ? "alarm_on" : "alarm_add";
    },
    selectedNote() {
      return this.$store.getters["user/notes/item"](this.docId);
    },
    t() {
      return this.$store.getters["app/trad/activa"];
    },
    txtSubrayados() {
      return this.selectedNote.txts ? this.selectedNote.txts : [];
    },
    txtRecordatorio() {
      if (this.alm === "") {
        return "Sin recordatorio";
      } else {
        return "Recordatorio: " + this.alm;
      }
    },
    txtZoom() {
      return "txt-zoom-" + this.userConfig.mdd.tam;
    }
  },
  methods: {
    updateTexts(field, value) {
      let obj = { id: this.docId, uidLocal: this.uidLocal, data: {} };
      obj.data[field] = value;
      this.$store.commit("user/notes/update", obj);
    },
    removeTime() {
      this.time = "";
      this.saveTime();
    },
    saveTime() {
      this.showTime = false;
      this.$store.commit("user/notes/update", {
        id: this.docId,
        uidLocal: this.uidLocal,
        data: { alm: this.time }
      });
    },
    eligeVdm(index) {
      this.$store.commit("user/notes/eligeVdm", {
        docId: this.docId,
        lectioCod: this.lectioCod,
        index: index,
        uidLocal: this.uidLocal
      });
    }
  }
};
</script>
